import {  Component, Vue } from "vue-property-decorator"
import { financeMarketCostStatisticalData, financeMarketCostStatisticalDataExport } from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'
import { formatDate } from '@/utils/timeFilter'
import {UserModule} from "@/store/modules/user";
const projectTypeFilter = [
  { key: '全部', value: 0 },
  { key: '国外小组科研', value: 1 },
  { key: '国内1对1', value: 2 },
  { key: '国外1对1', value: 3 },
  { key: '名校实验室', value: 4 },
  { key: 'AI HUB', value: 5 },
  { key: '全球华人导师', value: 6 },
  { key: '博雅计划-在线', value: 27 },
  { key: 'IEPQ线上项目', value: 30 },
  { key: '竞赛', value: 31 },
  { key: '全球华人导师-香港', value: 32 },
  {value: 38, key: '海外导师线下项目'},
  {value: 39, key: '国内导师线下项目'},
  {value: 40, key: '竞赛1v1'},
  {value: 42, key: 'IEPQ 1v1'},
  {value: 44, key: '全球华人导师-海外'},
  {value: 45, key: '企业导师远程实训'},
  {value: 47, key: '博雅计划-线下'},
  {value: 48, key: 'IEPQ 1v3'},
  {value: 49, key: '专业选修课'},
  {value: 50, key: 'IEPQ线下项目'},
  {value: 51, key: 'CERTIPORT认证课程'},
  {value: 52, key: '境外游学项目'},
  {value: 53, key: '竞赛线下（营地）'},
  {value: 54, key: '竞赛线下（研学）'},
]
@Component({})
export default class OrderStatisticsData extends Vue {

  page = 1
  limit = 20
  total = 0
  dissertationType = ''
  souCourseName = ''
  souCourseSchoolBegin = []
  tableData = []
  tableLoading = false
  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false
  customerName = ''
  status = ''
  marketCooperationName = ''
  types = ''
  timer = null
  // isReadonly = false
  payStatus = '' // 打款状态
  projectTypeFilter = projectTypeFilter //项目类型
  souCourseTypeId = ''
  createdUserId = ''
  financeOrderCreatedUserIdList = []
  reason =  '' //申请原因

  created() {
    this.getTableData()
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }
  // computed
  get userList() {
    return UserModule.userList
  }

  async getTableData() {
    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.tableLoading = true

    const { allNum, financeMarketCostList } = await financeMarketCostStatisticalData(delNullProperty({
      limit: this.limit,
      page: this.page,
      customerName : this.customerName,
      status: this.status,
      marketCooperationName : this.marketCooperationName,
      types : this.types,
      payStatus : this.payStatus,
      financeOrderCreatedUserIdList : this.financeOrderCreatedUserIdList,
      souCourseTypeId : this.souCourseTypeId,
      reason : this.reason,
    })) as unknown as { allNum: number; financeMarketCostList: any[] }
    this.tableData = financeMarketCostList
    this.total = allNum
    this.tableLoading = false
    // this.isReadonly = false
  }

  async exportExcel() {
    this.exportButtonDisabled = true
    this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    await financeMarketCostStatisticalDataExport(delNullProperty(
        {
          customerName: this.customerName,
          status: this.status,
          marketCooperationName: this.marketCooperationName,
          types: this.types,
          payStatus: this.payStatus,
          financeOrderCreatedUserIdList: this.financeOrderCreatedUserIdList,
          souCourseTypeId: this.souCourseTypeId,
          reason: this.reason,
        })
    )
    this.exportButtonDisabled = false
  }

  // pageChange(page: number) {
  //   this.page = page
  //   this.getTableData()
  // }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

}
